import { environment } from '../environments/environment';

export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch('/configs/environment.json', { cache: 'no-store' });
  const cfg = await response.json();

  environment.production = cfg.production ?? false;
  environment.baseApiUrl = cfg.baseApiUrl ?? '';
}
